import { useMemo } from "react";
import { formatEnumText } from "ui/utils/nameUtil";
import { LocationTypeEnum } from "app/services/api/types/calendar/enums/LocationTypeEnum";

import { useGetRolesListQuery } from "app/services/api/rolesApi";
import { RoleModel } from "app/services/api/types/roles/models/RoleModel";
import { useGetCalendarEventTypesQuery } from "app/services/api/calendarApi";

export function useHandleAppointmentForm() {
  const { data: rolesData, isLoading: areRolesLoading } =
    useGetRolesListQuery(undefined);

  const {
    data: eventTypesData,
    isLoading: areEventTypesLoading,
    isError: isEventTypesError,
  } = useGetCalendarEventTypesQuery();

  const typeOptions = useMemo(() => {
    return (
      eventTypesData?.event_types?.map((type) => ({
        value: type.value,
        label: type.label,
      })) || []
    );
  }, [eventTypesData]);

  const locationTypeOptions = Object.entries(LocationTypeEnum).map(
    ([key, value]) => ({
      value,
      label: formatEnumText(key),
    }),
  );

  const rolesOptions = useMemo(() => {
    return (
      rolesData?.map((role: RoleModel) => ({
        value: role.id,
        label: role.display_name,
      })) || []
    );
  }, [rolesData]);

  const additionalInformationOptions = [
    { label: "Transport required and booked", value: "booked" },
    { label: "Transport required and not booked", value: "not_booked" },
    { label: "No transport needed", value: "no_transport" },
  ];

  return {
    locationTypeOptions,
    typeOptions,
    rolesOptions,
    additionalInformationOptions,
    areRolesLoading,
    areEventTypesLoading,
    isEventTypesError,
  };
}
